import './assets/main.css'

import { createApp } from 'vue'
import App from './App.vue'
import { InitialData } from './types/types'

declare const distanceCalculatorData: { initialData: string | null } | undefined

const rootElement = document.getElementById('distance-calculator-vue3')

if (!rootElement) {
  console.error('Root element not found')
  throw new Error('Root element not found')
}

let initialData: InitialData = {}

if (typeof distanceCalculatorData !== 'undefined' && distanceCalculatorData.initialData) {
  initialData = JSON.parse(distanceCalculatorData.initialData)
} else {
  const data = rootElement?.dataset?.distanceCalculatorFields
  if (data) {
    initialData = JSON.parse(data)
  }
}

const app = createApp(App, {
  initialData
})

app.mount('#distance-calculator-vue3')
